import React from "react";

const BackAftercare = () => {
  return (
    <div className="faceWaxingContainer">
      <h2>
        Aftercare Tips for Body Back Waxing, De-tan & Threading in Bangalore
      </h2>{" "}
      <p>
        To maintain the results of your{" "}
        <a href="https://scentlifestyle.com/body-back-waxing-detan-threading-salon-in-bangalore">
          Body Back Waxing, De-tan & Threading in Bangalore
        </a>{" "}
        treatments, proper aftercare is essential:
      </p>
      <li>
        <span>After Body Back Waxing: </span> Moisturize regularly and avoid sun
        exposure for at least 24 hours. Exfoliate gently to prevent ingrown
        hairs and keep the skin smooth.
      </li>
      <li>
        <span>After De-tan Treatments:</span> Apply sunscreen daily to protect
        your skin from further sun damage. Stay hydrated and use gentle skincare
        products to maintain your skin’s brightness.
      </li>
      <li>
        <span>After Threading:</span> Keep the treated area clean and
        moisturized. Avoid using harsh products or exfoliants that could
        irritate the skin.
      </li>
    </div>
  );
};

export default BackAftercare;
